<template>
  <a-row>
    <a-row class="content-title" type="flex">
      <h2>Пользователи</h2>
      <a-button
        style="margin-left: auto"
        type="primary"
        @click="$router.push({ name: 'user-create' })"
      >
        <a-icon type="plus" />Добавить
      </a-button>
    </a-row>

    <a-table
      :columns="columns"
      :data-source="list"
      :loading="loading"
      :pagination="false"
    >
      <template slot="operation" slot-scope="item">
        <a-icon
          class="action-btns"
          type="edit"
          @click="
            $router.push({ name: 'user-detail', params: { id: item.id } })
          "
        />
        <a-popconfirm
          title="Вы действительно хотите удалить?"
          cancel-text="Нет"
          ok-text="Да"
          @confirm="removeUser(item)"
        >
          <a-icon class="action-btns" style="margin: 0 10px" type="delete" />
        </a-popconfirm>
      </template>
    </a-table>
    <a-pagination
      :current="+$route.query.page || 1"
      :page-size="+$route.query.limit || 10"
      :total="+count"
      class="mt-1"
      @change="onChange"
    />
    <!-- <pre>{{list}}</pre> -->
  </a-row>
</template>

<script>
// import { mapState } from "vuex"
const columns = [
  { title: "Логин", dataIndex: "username", key: "username", width: "90%" },
  // { title: "Дата регистрации", dataIndex: "created", key: "created" },
  {
    title: "Действие",
    key: "operation",
    scopedSlots: { customRender: "operation" }
  }
]

export default {
  data: () => ({
    list: [],
    loading: false,
    count: 0,
    columns
  }),
  // computed: {
  //   ...mapState({
  //     list: state => state.user.list || []
  //   })
  // },
  watch: {
    $route: {
      handler: "fetchList",
      immediate: true
    }
  },
  methods: {
    async fetchList() {
      this.loading = true
      // try {
      const { data, count } =
        (await this.$store.dispatch("user/fetchList", {
          page: +this.$route.query.page || 1,
          limit: +this.$route.query.limit || 10
        })) || []
      if (data) {
        this.list = data || []
      }
      this.count = count
      this.loading = false
    },
    async removeUser(arg) {
      try {
        const r = await this.$api.delete("/user/delete/" + arg.id)

        if (r && r.status >= 200 && r.status < 300) {
          const f = this.list.findIndex((item) => item.id == arg.id)

          if (f != -1) {
            this.list.splice(f, 1)
          }
        }
        // console.log(r)
      } catch (error) {
        console.log(error)
      }
    },
    onChange(pageNumber) {
      this.$router.push(
        {
          query: {
            ...this.$route.query,
            page: pageNumber
          }
        },
        () => {}
      )
    }
  }
}
</script>
<style scoped>
.mt-1 {
  margin-top: 15px;
}
</style>
